import { queryOptions } from "@tanstack/react-query";
import { getSupabase } from "@/shared/api/supabase";
import { parseRows } from "@/shared/lib/parse";
import { SettingSchema, type AppSettings, type Setting } from "@/shared/lib/db-schema";
import { keys } from "@/shared/lib/query-keys";
import { STALE_TIMES, GC_TIMES } from "@/shared/config/cache";

async function fetchSettings(): Promise<ReadonlyArray<Setting>> {
  const { data, error } = await getSupabase()
    .from("settings")
    .select("key,value,description,updated_at")
    .is("deleted_at", null);
  if (error) throw error;
  return parseRows(SettingSchema, data ?? [], "Setting");
}

async function fetchSettingsMap(): Promise<Partial<AppSettings>> {
  const rows = await fetchSettings();
  const out: Record<string, unknown> = {};
  for (const r of rows) out[r.key] = r.value;
  return out as Partial<AppSettings>;
}

/** All settings as a key→value map (consumed via useSettings). */
export function settingsMapOptions() {
  return queryOptions({
    queryKey: [...keys.settings.all, "map"] as const,
    queryFn: fetchSettingsMap,
    staleTime: STALE_TIMES.SETTINGS,
    gcTime: GC_TIMES.LONG,
  });
}
